import { ValidationError } from '@domain/errors';
import type { AuthenticatedAdmin } from '@domain/entities';
import type { AuthRepository } from '@domain/repositories';
import type { UseCase } from '../use-case';

export interface SignInInput {
  email: string;
  password: string;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export class SignIn implements UseCase<SignInInput, AuthenticatedAdmin> {
  constructor(private readonly repo: AuthRepository) {}

  async execute({ email, password }: SignInInput): Promise<AuthenticatedAdmin> {
    const fields: Record<string, string> = {};
    if (!EMAIL_RE.test(email.trim())) fields.email = 'Adresse e-mail invalide';
    if (password.trim().length < 6) fields.password = '6 caractères minimum';
    if (Object.keys(fields).length > 0) {
      throw new ValidationError('Identifiants invalides', fields);
    }
    return this.repo.signIn(email.trim().toLowerCase(), password);
  }
}

export class SignOut {
  constructor(private readonly repo: AuthRepository) {}
  execute(): Promise<void> {
    return this.repo.signOut();
  }
}

export class RestoreSession {
  constructor(private readonly repo: AuthRepository) {}
  execute(): Promise<AuthenticatedAdmin | null> {
    return this.repo.restoreSession();
  }
}
